import React, { Component } from 'react';
//import Camera from "../images/camera.jpg";
import backgroundImage from '../data/bg.jpeg';
import Calculator from '../Components/Calculator';
import server from '../Components/Server';
import { changeTeam, setMessage, setActiveMenu } from '../actions';
import { connect } from 'react-redux';
import { Waypoint } from 'react-waypoint';
import 'font-awesome/css/font-awesome.min.css';

class CalculatorBox extends Component {
  state = {
    showModal: false,
    counter: 0,
  };

  controller = new AbortController();

  handleClick = (e) => {
    if (
      e === 'close' ||
      e.target.classList.contains('close') ||
      e.target.classList.contains('calc-btn')
    ) {
      this.setState({
        showModal: !this.state.showModal,
      });
      document.querySelector('body').style.removeProperty('overflow');
      document.body.classList.toggle('modal-open');
      this.props.changeTeam(null);
      this.props.setMessage(null);
    }
  };

  componentDidMount() {
    fetch(server.counter, {
      method: 'GET',
      signal: this.controller.signal,
    })
      .then((response) => response.json())
      .then((data) => {
        this.setState({ counter: data.count });
      });
  }

  componentWillUnmount() {
    this.controller.abort();
  }

  render() {
    const { langBase } = this.props;

    return (
      <section className='calculator-view'>
        {this.state.showModal && (
          <div
            id='myModal'
            className='modal-custom'
            style={{ cursor: 'default' }}
          >
            <div
              className='modal-content-custom'
              style={{ width: '60%', minWidth: '304px' }}
            >
              <Calculator langBase={langBase} close={this.handleClick} />
            </div>
          </div>
        )}
        <div className='calc-box'>
          <div
            className='calc-img'
            style={{
              backgroundImage: `linear-gradient(black, black),url(${backgroundImage})`,
            }}
          >
            {/* <img src={Camera} alt="" /> */}
            {/* <Waypoint onEnter={() => this.props.setActiveMenu(1)} /> */}
            <div className='calc-slogan'>
              <h2>{langBase.online_calc}</h2>
              <p className='desc'>{langBase.calc_desc}</p>
            </div>
          </div>
          <Waypoint
            bottomOffset={300}
            onEnter={() => this.props.setActiveMenu(2)}
          />
          <div className='calc-button'>
            {this.state.counter && (
              <div className='counter'>
                <span>{langBase.used_by}</span>
                {this.state.counter}
                <span className='clients'>{langBase.clients}</span>
              </div>
            )}
            <button className='calc-btn' onClick={this.handleClick}>
              Calculator
            </button>
          </div>
        </div>
        <div className='calc-footer'>
          <a
            href='https://www.facebook.com/kalibripl/'
            rel='noopener noreferrer'
            terget='_blank'
          >
            <i className='fa fa-facebook-square' />
          </a>
          <a
            href='https://www.instagram.com/kalibri.pl/'
            rel='noopener noreferrer'
            terget='_blank'
          >
            <i className='fa fa-instagram' />
          </a>
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  langBase: state.langBase,
});

const mapDispatchToProps = {
  changeTeam,
  setMessage,
  setActiveMenu,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CalculatorBox);
